import BrandCard from "./BrandCard";

const brands = [
  {
    name: "OWL Creative",
    tagline: "Creative Studio",
    description:
      "Estúdio de Design e Comunicação em constante processo criativo, para desenvolver e comunicar as marcas e produtos dos nossos clientes.",
    services: ["Branding", "Design Gráfico", "Marketing Digital", "Fotografia", "Web"],
    colorClass: "text-owl",
    accentVar: "--owl-accent",
    website: "https://owlcreative.pt",
    number: "01",
  },
  {
    name: "EVOKE IT",
    tagline: "Innovation Studio",
    description:
      "Estúdio de inovação e tecnologia que desenvolve experiências para envolver, surpreender e conectar as marcas, a cultura e o seu público-alvo.",
    services: ["Museus", "Ativação de Marca", "Feiras", "Eventos", "Showroom"],
    colorClass: "text-evoke",
    accentVar: "--evoke-accent",
    website: "https://evoke.pt",
    number: "02",
  },
  {
    name: "Brand n' Play",
    tagline: "Amusement Factory",
    description:
      "Fábrica de entretenimento que disponibiliza soluções de gamificação e comunicação que potencializam a interação nos seus eventos.",
    services: ["Eventos", "Congressos", "Roadshows", "Festivais", "Pontos de Venda"],
    colorClass: "text-bnp",
    accentVar: "--bnp-accent",
    website: "https://brandnplay.com",
    number: "03",
  },
  {
    name: "Index Rerum",
    tagline: "Digital Archive",
    description:
      "Plataforma de catalogação e gestão de acervos que preserva e valoriza o património cultural e institucional dos nossos clientes.",
    services: ["Catalogação", "Acervos Digitais", "Património", "Gestão Documental"],
    colorClass: "text-index-rerum",
    accentVar: "--index-accent",
    website: "https://indexrerum.pt",
    number: "04",
  },
];

const BrandsSection = () => {
  return (
    <section id="brands" className="py-16 sm:py-24 md:py-32 relative section-alt">
      <div className="glow-orb w-[600px] h-[600px] bg-accent top-0 left-1/2 -translate-x-1/2" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
        <div className="mb-10 sm:mb-16 max-w-xl">
          <span className="section-label">As nossas marcas</span>
          <h2 className="section-heading">
            Quatro marcas,<br />
            a mesma excelência<br />
            <span className="text-accent">de serviço.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
          {brands.map((brand, i) => (
            <div
              key={brand.name}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <BrandCard {...brand} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
